export class DeleteModuleMasterVM {
    moduleID: number;
    modifiedBy: string;
}
